module.exports = __webpack_public_path__ + "img/news_1_2.706b57e8.jpg";